import { render, staticRenderFns } from "./vSelectEtnia.vue?vue&type=template&id=0d200bd6&scoped=true"
import script from "./vSelectEtnia.vue?vue&type=script&lang=js"
export * from "./vSelectEtnia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d200bd6",
  null
  
)

export default component.exports